module.exports = __webpack_public_path__ + "media/images/manage-offer/ideamotive-logo-0f43d44d6946a289043e5446557fe603.png";